<script lang="ts">
  import type { SVGAttributes } from 'svelte/elements';
  import { getIcon, icons, type IconId } from './Icon.definitions';

  interface Props extends SVGAttributes<SVGElement> {
    icon: IconId;
    class?: string;
    size?: string | number;
    title?: string;
    description?: string;
  }
  const { icon: iconId, class: className, size = '1em', title, description }: Props = $props();

  const icon = $derived(icons.find((icon) => icon.id === iconId) ?? getIcon('not-found'));
  const minX = $derived(icon.viewBox?.minX ?? 0);
  const minY = $derived(icon.viewBox?.minY ?? 0);
  const width = $derived(icon.viewBox?.width ?? icon.viewBox?.size ?? 24);
  const height = $derived(icon.viewBox?.height ?? icon.viewBox?.size ?? 24);
</script>

<svg class="app-icon app-icon-{iconId} {className}" width={size} height={size} viewBox="{minX} {minY} {width} {height}">
  {#if title}
    <title>{title}</title>
  {/if}
  {#if description}
    <desc>{description}</desc>
  {/if}
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html icon.body}
</svg>
